import "./index.scss";

export default props => {
    return (
        <div className={`page ${props.className || ''}`}>
            {props.children}
        </div>
    )
}